export default __webpack_public_path__ + "static/media/acc4.303a3ee7.jpg";